export * from './footer.component';